import React, { useContext, useState } from 'react';
import { Form, Segment } from 'semantic-ui-react';
import { PageContext } from '../../cnr/contexts/PageContext';

export const UpdateEventStatus = (props) => {

  const { settingsActionType, handleConfirmClicked } = props

  // pageContext
  const pageContext = useContext(PageContext);
  const { page_state, currentSettings_state } = pageContext ?? {}
  const { aps_global } = _.get(currentSettings_state, 'gvviSettings', {});
  const { settingsOptions } = aps_global ?? {}
  const { useDarkMode } = settingsOptions ?? {}

  // local state 
  const [meEventKey, setMeEventKey] = useState()

  const handleChange = (e, data) => setMeEventKey(data.value)

  const handleRemoveKey = () => handleConfirmClicked(settingsActionType, { meEventKey, deleteItem: true })
  const handleAddKey = () => handleConfirmClicked(settingsActionType, { meEventKey })

  const form = () => <Segment basic inverted={useDarkMode}>
    <Form>
      <Form.Input label={'Event Key'} onChange={handleChange}></Form.Input>
      <Form.Button disabled={!meEventKey} onClick={() => { handleRemoveKey() }}>Remove Key from ME</Form.Button>
      <Form.Button disabled={!meEventKey} onClick={() => { handleAddKey() }}>Add Key to ME</Form.Button>
    </Form>
  </Segment>

  const content = () => {
    return (
      <div className={'delete-container'}>
        {form()}
      </div>
    )
  }

  return content()

}